import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContractPartnerPrivateForm, ContractPartnerPrivateModel } from '../../new-contract-partner.utils';
import { CustomValidators } from '@shared-ikp/utils/validators';

export function buildPrivatePersonForm(formBuilder: FormBuilder, model?: ContractPartnerPrivateModel): FormGroup {
  return formBuilder.group<ContractPartnerPrivateForm>({
    firstName: formBuilder.control(model?.firstName || '', [Validators.required, CustomValidators.firstNameValidator]),
    lastName: formBuilder.control(model?.lastName || '', [Validators.required, CustomValidators.lastNameValidator]),
    birthDate: formBuilder.control(model?.birthDate || { day: null, month: null, year: null }, [
      Validators.required,
      CustomValidators.birthdateValidator,
    ]),
    email: formBuilder.control(model?.email || '', [Validators.required, CustomValidators.emailValidator]),
    phone: formBuilder.control(model?.phone || '', [CustomValidators.optionalPhoneNumberValidator]),
  });
}
